import{isTokenObject}from"./common.js";




const createSimpleTokenType=(name,tokenString)=>({
name,
testObject:testObject.bind(undefined,name),
serialize:serialize.bind(undefined,tokenString),
testString:testString.bind(undefined,tokenString),
parse:parse.bind(undefined,name),
normalize,
equals
});


const testObject=(type,token)=>isTokenObject(token,type);


const serialize=(tokenString)=>tokenString;


const testString=(tokenString,chars)=>chars===tokenString;


const parse=(type)=>({type});


const normalize=({type})=>({type});


const equals=()=>true;

export const ANY_TOKEN=createSimpleTokenType("any","*");
export const ANY_DEEP_TOKEN=createSimpleTokenType("anyDeep","**");